import { createContext } from 'react';

interface ShowChatBoxInterface {
	showChatBox: boolean;
	setShowChatBox:
		| React.Dispatch<React.SetStateAction<boolean>>
		| ((value: boolean) => void);
}

export const ShowChatBoxContext = createContext<ShowChatBoxInterface>({
	showChatBox: false,
	setShowChatBox: () => null,
});
